import {UserAction} from  '../../enum/user/userActions'
import {UserActionDescription} from  '../../enum/user/userActionDescription'
export class AuditLog
{
     userName:string;
     userAction:UserAction;
     screenName:string;
     screenPath:string;
     key?:string;
     value?:any;
     eventDescription?:UserActionDescription;
}
